export function sanitizeExternalHttpUrl(
  value: unknown,
  allowedHosts?: readonly string[],
): string {
  const candidate = String(value ?? "").trim();
  if (!candidate) return "";

  try {
    const url = new URL(candidate);
    if (!new Set(["http:", "https:"]).has(url.protocol)) return "";
    if (url.username || url.password) return "";
    if (allowedHosts && !allowedHosts.includes(url.host.toLowerCase())) return "";
    return url.href;
  } catch {
    return "";
  }
}

export function navigateToExternalUrl(url: string): void {
  window.location.assign(url);
}
